import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { PatronSearchPageComponent } from './patron-search-page.component';

@NgModule({
  declarations: [PatronSearchPageComponent],
  imports: [CommonModule, FormsModule, SharedModule],
  exports: [PatronSearchPageComponent],
})
export class PatronSearchPageModule {}
